import React from "react";
import Image from "react-bootstrap/Image";
import {Link} from "react-router-dom";
import VideoPlayer from "../video_player/videoPlayer";
import {Modal} from "react-bootstrap";
import ModalBase from "./ModalBase";

class VideoPlayerModal extends ModalBase {
    /**
     * Renders the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return this.renderVideoPlayer();
    };

    /**
     * Renders video player component within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderVideoPlayer = () => {
        const src = this.getVideoSource();

        return (
            <div className="video-player-container">
                <VideoPlayer src={src}/>
            </div>
        );
    };


    /**
     * Renders the header component.
     * @returns {React.ReactNode} The header component of the modal.
     */
    renderHeader = () => {
        const {headerTitle} = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title"> {headerTitle} </Modal.Title>
            </React.Fragment>
        );
    };

    renderFooter = () => {
    };


    /**
     * Getters
     */
    getVideoSource = () => {
        return '/videos/match.mp4';
    };

    static defaultProps = {
        ...super.defaultProps,
        playerProfileText: "View Player Profile",
        playerProfileLink: "#",
    };
}

export default VideoPlayerModal;
